import { Col, Row, Space } from 'antd'
import React from 'react'
import classes from './cpn.module.css'
function PageTitle(props) {
    return (
        <Row>
            <Col span={8} style={{display:"flex",alignItems:'flex-end',paddingBottom:"20px"}}></Col>
            <Col span={8}>
                <Space align='center' size='middle'>
                    <div className={classes.form_title}>{props.title}</div>
                    {props.right}
                </Space>
            </Col>
            <Col span={8} style={{display:"flex",alignItems:'flex-end',paddingBottom:"20px",justifyContent:"flex-end"}}></Col>
        </Row>
    )
}

export default PageTitle